import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Polygon } from 'react-google-maps';

import DeliveryZone from '../delivery-zone/DeliveryZone';

import './DeliveryAreas.scss';

class DeliveryAreas extends Component {

    renderExistingDeliveryZones(deliveryAreas) {
        const { areasStatus, updateDeliveryAreaEdit } = this.props;

        if (!deliveryAreas || (Array.isArray(deliveryAreas) && deliveryAreas.length === 0)) return null;

        const existingDeliveryAreas = deliveryAreas.map(area => {
            const isEditModeOn = areasStatus && areasStatus[area.tag] && areasStatus[area.tag].edit;

            return area.zones.map((zone, index) => {
                return (
                    <DeliveryZone key={area.tag + index}
                        areaName={area.tag}
                        zoneIndex={index}
                        paths={zone.boundaries}
                        isEditModeOn={isEditModeOn}
                        updateDeliveryAreaEdit={updateDeliveryAreaEdit}
                        />
                );
            });
        });

        return existingDeliveryAreas.reduce((accumulator, area) => {
            return accumulator.concat(area);
        });
    }

    renderGeneratedDeliveryZones(deliveryAreas) {
        return deliveryAreas.map((area, index) => {
            return <Polygon key={index}
                paths={area.zones}
                options={{
                    strokeColor: '#7d899e',
                    fillColor: area.color || '#40E0D0',
                    strokeOpacity: 0.58,
                    strokeWeight: 1,
                    fillOpacity: 0.5
                }}
            />;
        });
    }

    render() {
        const { restaurant, generatedDeliveryAreas } = this.props;

        return (
            <div>
                {this.renderExistingDeliveryZones(restaurant.deliveryAreas)}
                {this.renderGeneratedDeliveryZones(generatedDeliveryAreas)}
            </div>
        );
    }
}

DeliveryAreas.propTypes = {
    restaurant: PropTypes.object,
    areasStatus: PropTypes.object,
    generatedDeliveryAreas: PropTypes.array,
    updateDeliveryAreaEdit: PropTypes.func,
    
};

export default DeliveryAreas;
